import { FleekError } from './FleekError';

type Project = {
  id?: string;
  name?: string;
};

type ProjectNotFoundErrorOptions = {
  project: Project;
};

export class ProjectNotFoundError extends FleekError<ProjectNotFoundErrorOptions> {
  public name = 'ProjectNotFoundError';

  toString = () => 'Project not found.';
}
